import { buildAddedToCartPayload } from '../helpers/brazeHelper';
import { withItemsPayload } from './pulseItemsPayload';
import { trackImmediate } from './pulseTracker';
import type { PulseEventPartial } from './pulseSchema';
import { PULSE_VIEW_ID, resolvePhase1RouteViewId } from './pulseViewIds';

export const buildAddToCartPulsePartial = (
  cart: any,
  cartId: any,
  itemAdded: any,
  isItMobile: boolean,
  addedFromUpsellSection = false,
  page_path?: string
): PulseEventPartial => {
  const addedToCartPayload = buildAddedToCartPayload(
    cart,
    cartId,
    itemAdded,
    isItMobile,
    addedFromUpsellSection
  );
  const {
    selectedStore: _store,
    itemAdded: _items,
    ...brazePayload
  } = addedToCartPayload;
  const path =
    page_path ??
    (typeof window !== 'undefined' ? window.location.pathname : null);

  return {
    event_name: 'add_to_cart',
    view_id:
      (path ? resolvePhase1RouteViewId(path) : null) ?? PULSE_VIEW_ID.PRODUCT,
    page_path: path ?? undefined,
    cart_id: addedToCartPayload.cartId ?? null,
    ...withItemsPayload(brazePayload),
    action: 'add_to_cart',
  };
};

/** Pulse `add_to_cart` — immediate send (not batched); fail → retry queue. */
export const trackAddToCart = (
  cart: any,
  cartId: any,
  itemAdded: any,
  isItMobile: boolean,
  addedFromUpsellSection = false,
  page_path?: string
): void => {
  trackImmediate(
    buildAddToCartPulsePartial(
      cart,
      cartId,
      itemAdded,
      isItMobile,
      addedFromUpsellSection,
      page_path
    )
  );
};
